import { useState } from 'react';
import PropTypes from 'prop-types';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import TableSkeletonLoader from '../../../utils/TableSkeletonLoader';
import defaultImage from '../../../utils/DefaultImage';
import ImagePreviewModal from '../Components/ImagePreviewModal';
import DashboardTooltip from '../Components/DashboardTooltip';

const cleanImageUrl = (url) => {
    if (!url || url === "null" || typeof url !== "string") return null;
    let clean = url.trim();
    if (clean.startsWith("[")) {
        clean = clean.split('"]')[0].replace('["', '');
    }
    return clean;
};

const AllOrderView = (props) => {

    const {
        viewOrderData,
        isLoading,
    } = props;

    const [selectedImage, setSelectedImage] = useState(null);

    return (
        <>
            <div className="w-auto dash-table-main h-auto bg-[#FBFBFB] border-[2px] border-[#8B24332B] rounded-xl shadow overflow-hidden overflow-x-auto">
                <table className="lg:w-full min-w-[750px] text-left wine_table">
                    <thead>
                        <tr className="border-b-2 border-[#8B2433]/30 bg-[#FAF3F4]">
                            <th className="py-3.5 px-3 first:pl-6 text-left poppins-semibold text-[#8B2433] text-[13px] sm:text-sm whitespace-nowrap">
                                Sr.no
                            </th>
                            <th className="py-3.5 px-3 text-left poppins-semibold text-[#8B2433] text-[13px] sm:text-sm whitespace-nowrap">Immagine</th>
                            <th className="py-3.5 px-3 text-left poppins-semibold text-[#8B2433] text-[13px] sm:text-sm whitespace-nowrap">Nome</th>
                            <th className="py-3.5 px-3 text-left poppins-semibold text-[#8B2433] text-[13px] sm:text-sm whitespace-nowrap">Tipologia</th>
                            <th className="py-3.5 px-3 text-left poppins-semibold text-[#8B2433] text-[13px] sm:text-sm whitespace-nowrap">Nazione</th>
                            <th className="py-3.5 px-3 text-left poppins-semibold text-[#8B2433] text-[13px] sm:text-sm whitespace-nowrap">Prezzo</th>
                            <th className="py-3.5 px-3 text-left poppins-semibold text-[#8B2433] text-[13px] sm:text-sm whitespace-nowrap">IVA%</th>
                            <th className="py-3.5 px-3 text-left poppins-semibold text-[#8B2433] text-[13px] sm:text-sm whitespace-nowrap">Quantità</th>
                            <th className="py-3.5 px-3 last:pr-6 text-left poppins-semibold text-[#8B2433] text-[13px] sm:text-sm whitespace-nowrap">Prezzo totale</th>
                        </tr>
                    </thead>
                    {isLoading ? (
                        <TableSkeletonLoader
                            columns={9}
                            rows={5}
                            minWidths={["50px", "60px", "180px", "100px", "100px", "90px", "70px", "80px", "110px"]}
                            actionCount={0}
                        />
                    ) : (
                        <tbody>
                            {Array.isArray(viewOrderData) && viewOrderData?.length > 0 ? (
                                viewOrderData?.map((orderInfo, index) => (
                                    <tr key={index} className="border-b border-[#8B2433]/12 hover:bg-[#8B2433]/[0.03] transition-colors duration-150">
                                        <td className="py-4 px-3 first:pl-6 text-left poppins-medium text-[#303030] whitespace-nowrap text-sm">
                                            {index + 1}
                                        </td>
                                        <td className="py-4 px-3">
                                            <div
                                                className="thumbnail_image rounded-lg w-[50px] h-[60px] bg-white p-1 flex align-center justify-center cursor-pointer hover:shadow-md transition-shadow"
                                                onClick={() => setSelectedImage(cleanImageUrl(orderInfo?.wine?.image) || defaultImage)}
                                                title="Clicca per ingrandire"
                                            >
                                                <img
                                                    className="w-100 p-1 h-100 object-contain border border-[#68172394] rounded-lg"
                                                    src={cleanImageUrl(orderInfo?.wine?.image) || defaultImage}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = defaultImage;
                                                    }}
                                                    height={50}
                                                    width={50}
                                                    alt={orderInfo?.wine?.name || "wine"}
                                                />
                                            </div>
                                        </td>
                                        <td className="py-4 px-3 text-left poppins-medium text-[#303030] text-sm">
                                            <DashboardTooltip text={orderInfo?.wine?.name || 'N/A'} maxLength={25} />
                                        </td>
                                        <td className="py-4 px-3 text-left poppins-medium text-[#303030] text-sm">{orderInfo?.wine?.product_type || 'N/A'}</td>
                                        <td className="py-4 px-3 text-left poppins-medium text-[#303030] text-sm">{orderInfo?.wine?.nation || 'N/A'}</td>
                                        <td className="py-4 px-3 text-left poppins-medium text-[#303030] whitespace-nowrap text-sm font-mono">{orderInfo?.price ? `${Number(orderInfo?.price).toFixed(2)} €` : 'N/A'}</td>
                                        <td className="py-4 px-3 text-left poppins-medium text-[#303030] whitespace-nowrap text-sm">22%</td>
                                        <td className="py-4 px-3 text-left poppins-medium text-[#303030] whitespace-nowrap text-sm">
                                            <span className="inline-flex items-center justify-center bg-[#8B2433A6] text-white rounded-full min-w-[32px] h-[32px]">
                                                {orderInfo?.bottles_quantity || 0}
                                            </span>
                                        </td>

                                        <td className="py-4 px-3 last:pr-6 text-left poppins-semibold text-[#8B2433] whitespace-nowrap text-sm font-mono">
                                            {orderInfo?.price && orderInfo?.bottles_quantity
                                                ? (() => {
                                                    const basePrice = Number(orderInfo?.price) * Number(orderInfo?.bottles_quantity);
                                                    const taxAmount = basePrice * 0.22;
                                                    const totalPrice = basePrice + taxAmount;
                                                    return `${totalPrice.toFixed(2)} €`;
                                                })()
                                                : 'N/A'}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={9} className="text-center py-6 text-gray-500 poppins-medium">Nessun ordine trovato</td>
                                </tr>
                            )}
                        </tbody>
                    )}
                </table>
            </div>

            {isLoading ? (
                <SkeletonTheme baseColor="#E6DCDF" highlightColor="#FFFFFF">
                    <div className="py-2.5 sm:py-2 bg-[#FAF3F4] border-2 border-[#8B2433]/15 rounded-2xl sm:rounded-3xl flex justify-between sm:justify-end items-center px-4 sm:px-6 gap-3 sm:gap-6 mt-4 w-full">
                        <div className="w-24 sm:w-28">
                            <Skeleton height={20} borderRadius={6} />
                        </div>
                        <div className="w-36 sm:w-48">
                            <Skeleton height={20} borderRadius={6} />
                        </div>
                    </div>
                </SkeletonTheme>
            ) : (
                <div className="font-bold py-2.5 sm:py-2 bg-[#8A2533] text-white border-2 border-[#953543] transition-colors rounded-2xl sm:rounded-3xl flex justify-between sm:justify-end items-center px-4 sm:px-6 gap-3 sm:gap-6 mt-4 w-full">
                    <span className="w-auto text-left poppins-medium text-xs sm:text-base whitespace-nowrap">
                        Pezzi:{" "}
                        {Array.isArray(viewOrderData) && viewOrderData.length > 0
                            ? viewOrderData.reduce((sum, orderInfo) => sum + (parseInt(orderInfo.bottles_quantity) || 0), 0)
                            : 0}
                    </span>

                    <span className="w-auto text-right sm:text-center poppins-medium text-xs sm:text-base whitespace-nowrap">
                        Totale ordine:{" "}
                        {Array.isArray(viewOrderData) && viewOrderData.length > 0
                            ? `${viewOrderData.reduce((sum, orderInfo) => {
                                const basePrice = orderInfo?.price ? Number(orderInfo.price) * Number(orderInfo.bottles_quantity) : 0;
                                const taxAmount = basePrice * 0.22;
                                return sum + basePrice + taxAmount;
                            }, 0).toFixed(2)} €`
                            : "N/A"}
                    </span>
                </div>
            )}

            <ImagePreviewModal
                imageUrl={selectedImage}
                onClose={() => setSelectedImage(null)}
            />
        </>
    )
}

AllOrderView.propTypes = {
    viewOrderData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    isLoading: PropTypes.bool,
};

export default AllOrderView;